import { IDriverWallet } from "models/driverWallet";
import { ReactNode, createContext, useContext, useState } from "react";
import AddBalanceModal from "./AddBalanceModal";
import DeductBalanceModal from "./DeductBalanceModal";

interface IWalletAlertProps {
  showAdd: (wallet: IDriverWallet) => void;
  showDeduct: (wallet: IDriverWallet) => void;
}

export const WalletAlertContext = createContext<IWalletAlertProps>(
  {} as IWalletAlertProps
);

export const useWalletAlertContext = () =>
  useContext<IWalletAlertProps>(WalletAlertContext);

interface IOpen {
  open: boolean;
  wallet: IDriverWallet | null;
}

export function WalletAlertContextProvider({
  children,
}: {
  children: ReactNode;
}) {
  const [openAdd, setOpenAdd] = useState<IOpen>({
    open: false,
    wallet: null,
  });
  const [openDeduct, setOpenDeduct] = useState<IOpen>({
    open: false,
    wallet: null,
  });

  const showDeduct = (wallet: IDriverWallet) =>
    setOpenDeduct({ open: true, wallet });
  const handleCloseDeduct = () => setOpenDeduct({ open: false, wallet: null });
  const showAdd = (wallet: IDriverWallet) => setOpenAdd({ open: true, wallet });
  const handleCloseAdd = () => setOpenAdd({ open: false, wallet: null });

  return (
    <WalletAlertContext.Provider
      value={{
        showAdd,
        showDeduct,
      }}
    >
      {openAdd.wallet && (
        <AddBalanceModal
          open={openAdd.open}
          wallet={openAdd.wallet}
          handleClose={handleCloseAdd}
        />
      )}
      {openDeduct.wallet && (
        <DeductBalanceModal
          open={openDeduct.open}
          wallet={openDeduct.wallet}
          handleClose={handleCloseDeduct}
        />
      )}
      {children}
    </WalletAlertContext.Provider>
  );
}
